const roomSuffixRender = (number) => {
  if (number === 1) {
    return "pokój";
  } else if (number > 4) {
    return "pokoi";
  } else {
    return "pokoje";
  }
};

export default roomSuffixRender;
